<template>
  <div class="bank-info">
    <div class="title">
      <DeleteBankModal v-if="opendelet" @close="opendelet=false" @remove="deleteBank" />
      <img src="../../assets/icon/BANKINFOICON.png" alt="">
      <span>اطلاعات بانکی</span>
    </div>
    <div class="box">
      <div class="input-data-cart">
        <input class="public-input" type="text" placeholder="نام بانک" v-model="bankAccount.bankName" disabled="disabled">
        <input
         class="public-input"
          @input="dash2"
          type="text"
          v-model="bankAccount.cardNumber"
          maxlength="19"
          placeholder="شماره کارت"
        />
         <input
         class="public-input"

          @input="
            bankAccount.shebaCode = bankAccount.shebaCode.replace(
              /[^\d.]|\.\./gi,
              ''
            );
            error = '';
          "
          type="text"
          maxlength="24"
          v-model="bankAccount.shebaCode"
          placeholder="شماره شبا"
        />

        <!-- <custom-input bank="true" placeholder="نام بانک" type="text" @getValue="value => bankAccount.bankName = value" disabled="disabled"/>
        <p
            class="error"
            v-if="
            error.includes(bankAccount.cardNumber) &&
            bankAccount.cardNumber !== ''"
        >
          شماره کارت تکراریست
        </p>
        <custom-input placeholder="شماره کارت" type="text"
                      @getValue="value => bankinfo.numbercart = value"/>
        <custom-input placeholder="شماره شبا" type="text" @getValue="value => bankAccount.shebaCode = value"/> -->

        <img @click="addaccount" src="../../assets/icon/pluse.png" alt="">
      </div>

      <div class="add-cart-section">
        <div v-for="(bank , index) in data.bankAccounts" :key="index" class="cart-row">
<input class="public-input" type="text" :placeholder="bank.cardNumber"  disabled="disabled">
<input class="public-input" :placeholder="bank.shebaCode" type="text" disabled="disabled">
<input class="public-input" type="text" :placeholder="bank.bankName"  readonly="readonly">


          <!-- <custom-input  bank="true" :placeholder="bank.cardNumber" type="text" disabled="disabled"/>
          <custom-input :placeholder="bank.shebaCode" type="text" disabled="disabled"/>
          <custom-input :placeholder="bank.bankName" type="text" readonly="readonly"/> -->

          <img @click="opendelet=true" src="../../assets/icon/remove-icon.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const banks = {
  '603799': 'بانک ملی ایران',
  '589210': 'بانک سپه',
  '627648': 'بانک توسعه صادرات',
  '207177': 'بانک توسعه صادرات',
  '627353': 'بانک تجارت',
  '585983': 'بانک تجارت',
  '627961': 'بانک صنعت و معدن',
  '603770': 'بانک کشاورزی',
  '639217': 'بانک کشاورزی',
  '628023': 'بانک مسکن',
  '627760': 'پست بانک ایران',
  '502908': 'بانک توسعه تعاون',
  '627412': 'بانک اقتصاد نوین',
  '622106': 'بانک پارسیان',
  '639194': 'بانک پارسیان',
  '627884': 'بانک پارسیان',
  '502229': 'بانک پاسارگاد',
  '639347': 'بانک پاسارگاد',
  '639599': 'بانک قوامین',
  '504706': 'بانک شهر',
  '502806': 'بانک شهر',
  '603769': 'بانک صادرات',
  '610433': 'بانک ملت',
  '991975': 'بانک ملت',
  '589463': 'بانک رفاه',
  '502938': 'بانک دی',
  '639607': 'بانک سرمایه',
  '627381': 'بانک انصار',
  '505785': 'بانک ایران زمین',
  '636214': 'بانک آینده',
  '636949': 'بانک حکمت ایرانیان',
  '621986': 'بانک سامان',
  '639346': 'بانک سینا',
  '606373': 'بانک قرض الحسنه مهر',
  '627488': 'بانک کارآفرین',
  '502910': 'بانک کارآفرین',
  '505416': 'بانک گردشگری',
  '639370': 'بانک مهر اقتصاد',
  '628157': 'موسسه اعتباری توسعه',
  '505801': 'موسسه اعتباری کوثر',
}
import CustomInput from "../tools/custom-input";
import DeleteBankModal from './DeleteBankModal';

export default {
  name: "the-bank-info",
  components: {CustomInput, DeleteBankModal},
  props: ['data', 'error', 'change'],
  data() {
    return {
      cartData: [],

      bankinfo: {
        bankname: '',
        numbercart: '',
        sheba: ''
      },
      bankAccount: {
        shebaCode: '',
        cardNumber: '',
        bankName: ''
      },
      opendelet: false,
      bankIndex: ""
    }


  },

  methods: {
    addaccount() {
      if (this.bankAccount.shebaCode && this.bankAccount.cardNumber) {
        this.data.bankAccounts.push(this.bankAccount)
        this.$emit('addBank', this.bankAccount)
        this.bankAccount = {
          shebaCode: '',
          cardNumber: '',
          bankName: ''
        }
      }

    },
    removeaccount(e) {
      this.opendelet = true
      this.bankIndex = e
    },
    deleteBank() {
      this.data.bankAccounts.splice(this.bankIndex, 1)
      this.$emit('confirmDeleteBank')
    },
    dash(e) {
      this.data.bankAccounts[e].bankName = banks[this.data.bankAccounts[e].cardNumber ? this.data.bankAccounts[e].cardNumber.replace(/-/ig, '').slice(0, 6) : ''] || 'کارت نامعتبر'
      // this.data.bankAccounts[e].cardNumber = this.$separator(this.data.bankAccounts[e].cardNumber)
      this.error = ''
    },

    dash2() {
      this.bankAccount.bankName = banks[this.bankAccount.cardNumber ? this.bankAccount.cardNumber.replace(/-/ig, '').slice(0, 6) : ''] || 'کارت نامعتبر'
      this.bankAccount.cardNumber = this.$A2N(this.bankAccount.cardNumber)
      // this.bankAccount.cardNumber = this.$separator(this.bankAccount.cardNumber)
      this.error = ''
    },
    addCart() {
      this.cartData.push(this.bankinfo);
      this.bankinfo =
          {
            bankname: '',
            numbercart: '',
            sheba: ''
          }

    },

    removeCart(e) {
      this.cartData.splice(e, 1)
    },

    getval(value) {
      console.log(value)
    }

  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    for (let [index, item] of this.data.bankAccounts.entries()) {
      this.dash(index)
    }
  }
}
</script>

<style lang="scss" scoped>
.bank-info {
  display: flex;
  flex-direction: column;
  width: 100%;

  .title {
    display: flex;
    flex-direction: row;
    gap: 5px;
    align-items: center;
    font-size: clamp(16px, 1vw, 22px);
    color: #FFFFFF;

    img {
      width: 74px;
      height: 74px;
      margin-right: -10px;
    }
  }

  .box {
    position: relative;
    padding: 40px;

    &::before {
      background-image: url("../../assets/backgrounds/kyc-BOX.png");
      background-size: auto;
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      opacity: 0.4;
      width: 100%;
      height: 100%;
      border-radius: 20px;
      z-index: 0;
    }

    .input-data-cart {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 45px;
      justify-content: space-between;
      align-items: center;
input{
flex-grow: 1;
flex-basis: 100px;
max-width: 332px;
height: 52px;
z-index: 1;
}
      img {
        z-index: 10;
      }
    }

    .add-cart-section {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 20px;
      align-items: start;
      height: 170px;
      overflow: auto;
      margin-top: 40px;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
input{
flex-grow: 1;
flex-basis: 100px;
max-width: 332px;
height: 52px;
z-index: 1;
} 


      .cart-row {
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;

        img {
          z-index: 10;
          cursor: pointer;
        }
      }
    }

  }
}
</style>